import React, { useState } from 'react';
import axios from 'axios';
import { ASSISTANT_AUTH_RECOVER_URL } from '../constants'; // ✅ Importa la ruta desde constants.js

const RecoverPassword = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(null);
        setError(null);

        console.log("✅ Recuperación de contraseña: Enviando POST a", ASSISTANT_AUTH_RECOVER_URL);

        try {
            const res = await axios.post(ASSISTANT_AUTH_RECOVER_URL, { email });

            console.log("✅ Respuesta del servidor:", res.data);
            setSuccess('Si el correo está registrado, recibirás un enlace para recuperar tu contraseña.');
        } catch (err) {
            console.error("❌ Error al enviar solicitud de recuperación:", err);
            setError('Hubo un error al intentar enviar el correo. Intenta nuevamente.');
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white shadow-md rounded-lg">
                <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Recuperar contraseña</h2>
                <p className="text-sm text-gray-600 text-center mb-6">Ingresa tu correo y te enviaremos instrucciones</p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
                        <input
                            type="email"
                            name="email"
                            placeholder="ejemplo@correo.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Enviar instrucciones
                    </button>
                </form>

                {success && <p className="mt-4 text-green-600 text-sm text-center">{success}</p>}
                {error && <p className="mt-4 text-red-600 text-sm text-center">{error}</p>}
            </div>
        </div>
    );
};

export default RecoverPassword;
